// extracted by mini-css-extract-plugin
export default {"access_for_all_section":"access_for_all_section___aANz5","access_for_all_block":"access_for_all_block___VG7T4","img":"img___Xe0my"};